import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function TermsAndConditions() {
  return (
    <section className="relative py-28 bg-gradient-to-b from-[#0A2A66] via-[#133C91] to-[#0A2A66] text-white overflow-hidden">
      {/* Subtle mesh backdrop */}
      <div className="pointer-events-none absolute inset-0 opacity-25 mix-blend-screen">
        <svg
          className="w-full h-full"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid slice"
        >
          <defs>
            <pattern
              id="meshGrid"
              width="40"
              height="40"
              patternUnits="userSpaceOnUse"
            >
              <path
                d="M40 0H0V40"
                fill="none"
                stroke="#ffffff"
                strokeOpacity="0.18"
                strokeWidth="1"
              />
            </pattern>
            <radialGradient id="rg" cx="35%" cy="25%" r="70%">
              <stop offset="0%" stopColor="#4bd3ff" stopOpacity="0.32" />
              <stop offset="100%" stopColor="#000" stopOpacity="0" />
            </radialGradient>
          </defs>
          <rect width="100%" height="100%" fill="url(#meshGrid)" />
          <rect width="100%" height="100%" fill="url(#rg)" />
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 leading-relaxed">
        <motion.h1
          className="text-4xl md:text-5xl font-bold mb-10 text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Terms & Conditions
        </motion.h1>

        <motion.div
          className="space-y-6 text-white/90 text-lg"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <p>
            By accessing or using QuantNexusCapital services, you agree to these
            Terms & Conditions. If you do not agree, you should discontinue use
            immediately.
          </p>

          <ul className="list-disc pl-6 space-y-3">
            <li>
              <strong>Best-effort services:</strong> All vaults and strategies
              are provided on a best-effort basis, without guarantees of
              accuracy, uptime, or specific returns.
            </li>
            <li>
              <strong>Compliance responsibility:</strong> You are solely
              responsible for ensuring compliance with the laws and regulations
              in your jurisdiction before allocating capital.
            </li>
            <li>
              <strong>Risk acknowledgment:</strong> Vault allocations are at
              your own risk. QuantNexusCapital accepts no liability for financial
              losses, missed opportunities, or market volatility.
            </li>
            <li>
              <strong>Updates:</strong> These Terms may be updated periodically.
              Continued use of our services constitutes acceptance of the latest
              version.
            </li>
          </ul>

          <p>
            By engaging with QuantNexusCapital, you acknowledge the inherent
            risks of decentralized finance and agree to use our services
            responsibly.
          </p>
        </motion.div>

        {/* Back to Home button */}
        <div className="mt-12 text-center">
          <Link
            to="/"
            className="inline-block px-6 py-3 rounded-xl bg-gradient-to-r from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white font-semibold shadow-lg transition"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </section>
  );
}

export default TermsAndConditions;
